import React from 'react';
import Helmet from 'react-helmet';
import MainMenu from '@/Shared/MainMenu';
import FlashMessages from '@/Shared/FlashMessages';
import TopHeader from '@/Shared/TopHeader';
import BottomHeader from '@/Shared/BottomHeader';
import { Provider } from 'react-redux';
import store from '@/Store/store';
import MainModal from '@/Modals/MainModal';
import CustomReactTooltip from '@/Shared/CustomReactTooltip';

export default function Layout({ title, children }) {

  return (
    <div>
      <Provider store={store}>
      <Helmet titleTemplate="%s | Admin Panel" title={title} />
      <div className="flex flex-col">
        <div className="flex flex-col h-screen">
          <div className="md:flex">
            <TopHeader />
            <BottomHeader />
          </div>
          <div className="flex flex-grow overflow-hidden">
            <MainMenu className="flex-shrink-0 hidden w-56 p-12 overflow-y-auto bg-indigo-800 md:block" />
      {/*      /!* To reset scroll region (https://inertiajs.com/pages#scroll-regions) add `scroll-region="true"` to div below *!/*/}
            <div className="w-full px-4 py-8 overflow-hidden overflow-y-auto md:p-12">
              <FlashMessages />
              {children}
            </div>
          </div>
        </div>
      </div>
        <MainModal/>
        <CustomReactTooltip/>
      </Provider>
    </div>
  );
}
